import { render } from "./VideoHome.vue?vue&type=template&id=c05c2a9c&scoped=true"
import script from "./VideoHome.vue?vue&type=script&lang=js"
export * from "./VideoHome.vue?vue&type=script&lang=js"

import "./VideoHome.vue?vue&type=style&index=0&id=c05c2a9c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05c2a9c"]])

export default __exports__